// App components
export * from "./registration.component";
export * from "./registration.module";
export * from "./registration.route";






// WEBPACK FOOTER //
// ./src/app/modules/registration/index.ts